<template>
  <sds-input-control :label="label">
    <web-sds-date-field
      :aria-label="label"
      :data-testid="label + '-date-field'"
      v-bind="$attrs"
      :value="data"
      @sdsChange="
        emit('input:field', $event.detail.value);
        emit('input', $event.detail.value);
      "
      @sdsFieldInputChange="emit('input:field', $event.detail.value)"
      @sdsFocus="emit('focus', $event)"
      @sdsBlur="emit('blur', $event)"
      @sdsOpen="emit('open', $event)"
      @sdsClose="emit('close', $event)"
    />
  </sds-input-control>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { useVModel } from '@vueuse/core';

type Emits = {
  (e: 'input:field', value: string): void;
  (e: 'input', value: Date | null): void;
  (e: 'focus', value: CustomEvent): void;
  (e: 'blur', value: CustomEvent): void;
  (e: 'open', value: CustomEvent): void;
  (e: 'close', value: CustomEvent): void;
};

const props = defineProps({
  value: {
    type: null as unknown as PropType<string | null>,
    required: true,
  },
  label: {
    type: String,
    required: false,
    default: null,
  },
});

const emit = defineEmits<Emits>();
const data = useVModel(props, undefined, emit);
</script>
